import { AloftArea, MLSListing } from '@aloft/toolkit-shared';

import { MLSDataColumn } from './MLSDataColumn.tsx';
import { MLSDataInfoSection } from './MLSDataInfoSection.tsx';
import { MLSDataValueWithLabel } from './MLSDataValueWithLabel.tsx';
import { getLotAreaSqftString } from './utils/getLotAreaSqftString.ts';

export const MLSSiteInfo = ({ listingData }: { listingData: MLSListing }) => (
  <MLSDataInfoSection title="Site">
    <MLSDataColumn>
      <MLSDataValueWithLabel value={getLotAreaSqftString(listingData)} label="Lot Size (Sq Ft)" />
      <MLSDataValueWithLabel
        value={
          listingData.LotSizeAcres
            ? AloftArea.fromNumber(listingData.LotSizeAcres, 'acre').toString()
            : undefined
        }
        label="Lot Acres"
      />
      <MLSDataValueWithLabel value={listingData.WaterSource?.join(', ')} label="Water" />
      <MLSDataValueWithLabel value={listingData.Sewer} label="Sewer" />
      <MLSDataValueWithLabel value={listingData.LotFeatures} label="Lot Description" />
    </MLSDataColumn>
    <MLSDataColumn>
      <MLSDataValueWithLabel value={listingData.Topography} label="Topography" />
      <MLSDataValueWithLabel value={listingData.View} label="View" />
      <MLSDataValueWithLabel value={listingData.WaterFrontYN} label="Waterfront" />
      {listingData.WaterFrontYN && (
        <MLSDataValueWithLabel value={listingData.WaterFrontFeatures} label="Waterfront Features" />
      )}
      <MLSDataValueWithLabel value={listingData.ParcelNumber} label="Parcel Number" />
    </MLSDataColumn>
  </MLSDataInfoSection>
);
